<template>
  <div
    aria-roledescription="table-header"
    class="border-b-2 border-gray-900/10 text-gray-700"
  >
    <CarvisTableSort
      :item-description="itemDescription"
      :limit="limit"
      :limit-options="limitOptions"
      :sort-by="sortBy"
      :sort-options="sortOptions"
      @update:limit="$emit('update:limit', $event)"
      @update:sort-by="$emit('update:sortBy', $event)"
    />
  </div>
</template>

<script setup lang="ts" generic="T">
defineProps<{
  limitOptions: { value: number | null; label: string }[]
  sortOptions: { value: SortBy<T>, label: string }[]
  limit: number | null
  sortBy: SortBy<T>
  itemDescription: string
}>()

defineEmits(['update:limit', 'update:sortBy'])
</script>
